var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "message-stream"
  }, [_vm.isCursorBlinking ? _c('span', {
    staticClass: "blinking-cursor"
  }, [_vm._v("|")]) : _vm._e(), _c('div', {
    ref: "preRef",
    class: ['message-marked'],
    domProps: {
      "innerHTML": _vm._s(_vm.displayedContent)
    }
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }